import React from 'react';

const AgentContext = React.createContext<{
  userAgent: string;
}>({
  userAgent: ``,
});

export default AgentContext;
